import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { TournamentUser } from '../tournament-user.model';

@JsonObject('TournamentUsersResultsResponse')
export class TournamentUsersResultsResponse extends ApiResultsResponse<TournamentUser> {

  @JsonProperty('results', [TournamentUser])
  override results: TournamentUser[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
